var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IncentivesPeriodConfig_1;
/* eslint-disable import/no-duplicates */
import { StringToolVariable, ToolType } from '@symon-ai/wisepipe-base-pipe';
import { Column, PeriodColumnMetadata } from '@symon-ai/wisepipe-common-data';
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import './incentivesPeriodColumn'; // force import for JSON schema
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationResult } from './validation/toolValidationResult';
import { validateSourceWithDetail } from './validation/validateHelper';
const schema = {
    $id: 'urn:wisepipe-common-pipe:IncentivesPeriodConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:IncentivesPeriodColumn' },
            minItems: 1,
            maxItems: 1000,
            uniqueItemProperties: ['newColumnName']
        }
    },
    required: ['columns']
};
let IncentivesPeriodConfig = IncentivesPeriodConfig_1 = class IncentivesPeriodConfig extends ToolConfig {
    constructor(columns, customFormats) {
        super(ToolType.INCENTIVES_PERIOD, customFormats);
        this.columns = columns;
        JSON.validate(this, IncentivesPeriodConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return IncentivesPeriodConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return IncentivesPeriodConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return IncentivesPeriodConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return IncentivesPeriodConfig_1.outs;
    }
    static get in() {
        return IncentivesPeriodConfig_1.ins[0];
    }
    static get out() {
        return IncentivesPeriodConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo('Period', [ToolCategories.ORGANIZE], this.ins, this.outs, ['period', 'date', 'incentives'], true);
    }
    applyParameters(parameters) {
        return new IncentivesPeriodConfig_1(parameters.getAppliedVals(this.columns), this.customFormats);
    }
    getBaseValues(parameters) {
        return { columns: this.columns.map((c) => c.getBaseValues(parameters)) };
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const baseVals = this.getBaseValues(iConfigHelper.getParameters());
        const exp = tsb.export(this.out);
        exp.copyAll(this.in);
        baseVals.columns.forEach((c) => {
            const sourceColumn = exp.findSourceColumn(this.in, c.sourceColumnName);
            if (sourceColumn) {
                exp.makeNew(new Column(c.newColumnName, 'period', new PeriodColumnMetadata(c.targetCalendarID, c.targetPeriodLevel)), [sourceColumn], true);
            }
        });
        exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, ins) {
        const toolValidationResult = this.getToolValidationResult(iConfigHelper, ins);
        return toolValidationResult.validationState;
    }
    getToolValidationResult(iConfigHelper, ins) {
        const source = ins.schemas.at(this.in);
        if (!source) {
            return ToolValidationResult.getMissingSourceColumnsResult();
        }
        const inputs = new Map();
        const baseVals = this.getBaseValues(iConfigHelper.getParameters());
        for (const c of baseVals.columns) {
            // If the source column is being used multiple times, confirm it has the same type in each config
            if (!inputs.has(c.sourceColumnName)) {
                inputs.set(c.sourceColumnName, [c.sourceColumnType]);
            }
            else if (inputs.get(c.sourceColumnName)?.[0] !== c.sourceColumnType) {
                return ToolValidationResult.getBadMetadataResult(`Column ${c.sourceColumnName} is used multiple times with different types.`, `Double check the source column types for ${c.sourceColumnName} and ensure they are consistent.`);
            }
        }
        const outputs = baseVals.columns.map((c) => c.newColumnName);
        const sourceValidationResult = validateSourceWithDetail(source, inputs, outputs);
        return ToolValidationResult.getResultFromSourceValidation(sourceValidationResult);
    }
    calendarIDs() {
        return this.columns.map((c) => {
            if (c.targetCalendarID instanceof StringToolVariable)
                throw new Error('Please apply parameters first');
            return c.targetCalendarID;
        });
    }
};
IncentivesPeriodConfig = IncentivesPeriodConfig_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ToolType.INCENTIVES_PERIOD)
], IncentivesPeriodConfig);
export { IncentivesPeriodConfig };
//# sourceMappingURL=incentivesPeriodConfig.js.map